import axios from 'axios'
import maps from '@/generated/maps.js'

export default function () {
  return {
    namespaced: true,
    state: () => {
      const state = {}

      Object.keys(maps.App_Models_SavedFilter.typesMap).forEach((type) => {
        state[type] = {
          loaded: false,
          loading: false,
          data: [],
        }
      })

      return state
    },
    mutations: {
      loading(state, { type }) {
        state[type] = {
          loaded: false,
          loading: true,
          data: [],
        }
      },
      loaded(state, { type, data }) {
        state[type] = {
          loaded: true,
          loading: false,
          data,
        }
      },
    },
    actions: {
      loadData({ commit, state }, { type, force = false }) {
        if ((force || !state[type].loaded) && !state[type].loading) {
          commit('loading', { type })
          axios.get(Spark.router('api.saved_filter.index', { type }))
            .then((resp) => {
              commit('loaded', { type, data: resp.data })
            })
        }
      },
    },
  }
}
